import client from "./clients/portalClient";

const getTasks = () => client.get(`/dashboard/my_tasks`);
const getPlanning = () => client.get(`/dashboard/sales_planning`);
const getGeneral = () => client.get(`/dashboard/general`);
const getRevenueInfo = () => client.get(`/dashboard/revenue`);
const getProductivityInfo = () => client.get(`/dashboard/productivity`);

const getProductivityDepartmentInfo = () => client.get(`/productivity_department`);
const getProductivityDepartmentUserInfo = (department) => client.get(`/productivity_department/details?department=${department}`);
const getKingActualProductivityData = () => client.get(`/productivity_barchart`);

const dashboardApi = {
    getTasks,
    getPlanning,
    getGeneral,
    getRevenueInfo,
    getProductivityInfo,
    getProductivityDepartmentInfo,
    getProductivityDepartmentUserInfo,
    getKingActualProductivityData,
};

export default dashboardApi;